import { render, staticRenderFns } from "./UploadFullTextPdfController.vue?vue&type=template&id=39bc32f8&"
import script from "./UploadFullTextPdfController.vue?vue&type=script&lang=js&"
export * from "./UploadFullTextPdfController.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VRow})
